import React from "react";
import "../Assets/css/influencer.css";
import { useNavigate } from "react-router-dom";
import { Grid, Typography, Box, useMediaQuery } from "@mui/material";
import BackVector from "../Assets/Img/BackVector.svg";
import Mailbox from "../Assets/Img/mailbox.svg";
import LocationSVG from "../Assets/Img/LocationSVG.svg";
import Sampleimg from "../Assets/Img/sampleimg.png";
import InstagramIcon from "../Assets/Img/instagramICON.svg";
import YoutubeButton from "../Assets/Img/youtubeButton.svg";
import InstaAcoordian from "../Main/InstaAcoordian";
import YoutubeAccordian from "../Main/YoutubeAccordian";

function InfluencerStats() {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  return (
    <div className="content" style={{ padding: isSmallScreen ? "10px" : "20px" }}>
      <div style={{ marginBottom: "10px" }}>
        <nav>
          <span style={{ fontSize: "18px", color: "black" }}>
            <a
              href="/brand-home"
              style={{
                textDecoration: "none",
                color: "black",
                fontWeight: window.location.pathname === "/brand-home" ? "bold" : "normal",
              }}
            >
              Home
            </a>{" "}>{" "}
          </span>
          <span style={{ fontSize: "18px", color: "black" }}>
            <a
              href="/influencerstats"
              style={{
                textDecoration: "none",
                color: "black",
                fontWeight: window.location.pathname === "/influencerstats" ? "bold" : "normal",
              }}
            >
               Statistics
            </a>
          </span>
        </nav>
      </div>

      <Box className="stat-item">
        <div className="contact-container">
          <Grid container spacing={2}>
            {/* Contact Section */}
            <Grid item xs={12} sm={6} md={4}>
              <Box className="contact">
                <Typography variant="h6" className="contact-detail">
                  Contact
                </Typography>
                <Box className="contact-details">
                  <Box className="sub-div" display="flex" alignItems="center" onClick={() => window.open("mailto:johnmorgan@gmail.com", "_self")} style={{ cursor: "pointer" }}>
                    <img src={Mailbox} alt="mail" />
                    <small> johnmorgan@gmail.com</small>
                  </Box>
                  <Box className="sub-div" display="flex" alignItems="center">
                    <img src={LocationSVG} alt="location" />
                    <small> Andheri west, Mumbai</small>
                  </Box>
                </Box>
              </Box>
            </Grid>

            {/* Profile Section */}
            <Grid item xs={12} sm={6} md={4}>
              <Box className="profile" textAlign="center">
                <Typography variant="h5" className="user-name">
                  Cardi B
                </Typography>
                <Box className="image-box" mt={2}>
                  <img
                    src={Sampleimg}
                    alt="img"
                    style={{ width: "100%", borderRadius: "8px" }}
                  />
                </Box>
                <Typography variant="body2" className="category">
                  Fashion
                </Typography>
              </Box>
            </Grid>

            {/* Socials Section */}
            <Grid item xs={12} sm={6} md={4}>
              <Box className="contact">
                <Typography variant="h6" className="contact-detail">
                  Socials
                </Typography>
                <Box className="contact-details">
                  <Box className="sub-div" display="flex" alignItems="center" onClick={() => window.open("https://www.instagram.com/in_social_orbit/", "_blank")} style={{ cursor: "pointer" }}>
                    <img src={InstagramIcon} alt="instagram" />
                    <small>john_morgan</small>
                  </Box>
                  <Box className="sub-div" display="flex" alignItems="center" onClick={() => window.open("https://www.youtube.com/@realtalkclipp", "_blank")} style={{ cursor: "pointer" }}>
                    <img src={YoutubeButton} alt="youtube" className="youtube" />
                    <small>@realtalkclipp</small>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </div>
        <InstaAcoordian />
        <YoutubeAccordian />
      </Box>
    </div>
  );
}

export default InfluencerStats;
